<template>
  <div class="page-content">
    <el-row type="flex" justify="center" class="page-body">
      <el-col :xs="{span: 24}" :sm="{span: 24}" class="content-wrapper home-row">
        <el-row type="flex" justify="left">
          <el-col :xs="{span: 24}" :sm="{span: 24}" class="home">
            <el-image :src="images.texture" class="home-image-texture"></el-image>
            <el-image :src="images.home" class="home-image"></el-image>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {},
  data () {
    return {
      images: {
        home: require('@/assets/home.png'),
        texture: require('@/assets/texture_2.png'),
      }
    }
  },
  methods: {
  }
}
</script>
